<template>
  <div id="page-tipsfileUpload" class="d-flex">
    <!-- main bar -->
    <MainBarMenuV2 />
    <!-- end -->
    <div class="header-top">
      <div class="container-fluid">
        <!-- header -->
        <HeadingUser />
        <!-- end -->
      </div>
    </div>
    <div class="layout-content container-fluid mt-5" >

      <div class="page-tipsfileUpload py-3">
        <div class="container">
          <!-- header siesa -->
          <h2 class="mb-4 ml-4"> <b>Carga de archivo AS400</b></h2>


          <h3 class="mb-4 ml-4">

            Carga y consulta diariamente tus archivos de propinas AS400
          </h3>

          <div class="row">
            <!--<FileUpload />-->
            <div class="col-md-6">
              <label @dragover.prevent @drop.prevent for="file_drop" class="col-md-12">

                <!-- carga de archivo -->
                <div class="alert highlight-success">
                  <img class="mr-2 mt-1" style="margin-left: 5px; position: relative; top: 1px !important;"
                    src="@/assets/images/icons/icon-information-fill.svg" />
                  <span class="body_regular " style="color: #000000;"> Carga el archivo de propinas <b>AS400</b> del día
                    de ayer </span>
                </div>
                <!-- end -->

                <!-- Drop file  -->
                <div @drop="dragFile" class="col-12 mb-4 pt-4 drag-file is-invalid">
                  <!-- cuando el archivo se esta cargando -->
                  <div class="col-12" v-if="processing">
                    <div class="div-header">
                      {{ file[0].name }}
                    </div>
                    <div class="div-content">
                      <div class="cargando ml-4 mr-4"></div> El archivo se está subiendo
                    </div>
                  </div>
                  <!-- subida de file -->
                  <div class="col-12" v-else>
                    <!-- logica para subir el archivo -->
                    <div style="margin-top:32px;">
                      <!-- subir archivo -->
                      <div v-if="file[0] == null">
                        <img class="mb-6 ml-4" src="@/assets/images/icons/inbox-unarchive-fill.svg" />
                        <h1 style="font-size:100px;">


                        </h1>
                        <p>
                          Arrastra aquí el archivo de reporte <b>AS400</b> o haz
                          <label class=" table-value" style="color:#0C9E42;text-decoration: underline #0C9E42; ">clic
                            aquí
                            <input type="file" id="file_drop" @change="dragFile"
                              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                              style="display:none">
                          </label>
                          para buscarlo en tu dispositivo.
                        </p>
                      </div>
                      <!-- end -->
                      <div v-else>
                        <!-- si existe un error -->
                        <div v-if="getErrors.file">
                          <h1 style="font-size:100px;">
                            <span class="icon icon-cancel-circle" />
                          </h1>
                          <p>
                            {{ getErrors.file }}
                            <b-button class="mt-3" variant="outline-danger" block @click.prevent="reset_file">
                              Volver a intentar
                            </b-button>
                          </p>
                        </div>
                        <!-- end -->
                        <!-- todo esta ok -->
                        <div v-else>
                          <h1 style="font-size:100px; color:#0C9E42">
                            <span class="icon icon-checkmark" />
                          </h1>
                          <p>
                            ¡Genial! has cargado exitosamente el archivo {{ file[0].name }}
                            Ahora puedes consultar los reportes de los Puntos de Venta que tienes asignados.
                          </p>
                        </div>
                        <!-- end -->
                      </div>
                    </div>
                    <!-- end -->
                    <!-- ok si el archivo se sube -->
                    <!-- <div v-if="file.length">
                      <h1 style="font-size:100px; color:#0C9E42">
                        <span class="icon icon-checkmark" />
                      </h1>
                      <p>
                        ¡Genial! has cargado exitosamente el archivo {{ file[0].name }}
                        Ahora puedes consultar los reportes de los Puntos de Venta que tienes asignados.
                      </p>
                    </div> -->
                    <!-- end -->
                    <!-- subir archivo
                    <div v-if="file[0] == null">
                      <h1 style="font-size:100px;">
                        <span class="icon icon-upload" />
                      </h1>
                      <p>
                        Arrastra aquí el archivo de reporte mensual de AS400 o haz 
                        <label class="btn btn-link">clic aquí
                          <input
                              type="file"
                              id="file_drop"
                              @change="dragFile"
                              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                              style="display:none">
                        </label>
                        para buscarlo en tu dispositivo.
                      </p>                 
                    </div>
                     end -->
                  </div>
                </div>
              </label>

              <!-- alerta de mensaje de archivos pendientes -->
              <!--<div class="alert alert-danger alert-panel mt-4">
                  <p class="text-alert-danger">
                    <span class="icon icon-warning text-warning" />
                    ¡Recuerda!, todavía tienes archivos pendientes por cargar. Verifica en el listado de
                    <b>Reportes por día del mes de septiembre.</b>
                  </p>
                </div> -->
              <!-- end -->
            </div>

            <!-- daily report siesa -->
            <div class="col-md-6">
              <DailyReportSiesa />
            </div>
            <!-- end -->
          </div>
          <!-- .row -->
        </div>

        <!-- modal -->
        <div>
          <b-modal :ref="modal_name" hide-footer centered title="Atención al mensaje:" no-close-on-backdrop
            @hidden="hideModal(modal_name)">
            <div class="d-block text-center">
              <h3>{{ getErrors.file }}</h3>
            </div>
            <b-button class="mt-3" variant="outline-danger" block @click="hideModal(modal_name)">
              Cerrar
            </b-button>
          </b-modal>
        </div>
        <!-- end -->

      </div>
    </div>
  </div>
  <!-- #page-request -->
</template>

<script>
import {
  mapGetters,
  mapActions
} from "vuex"

export default {
  name: "TipsfileUpload",
  components: {
    MainBarMenuV2: () => import("@/components/layouts/MainBarMenuV2.vue"),
    HeadingUser: () => import("@/components/user/HeadingUser.vue"),
    DailyReportSiesa: () => import("@/components/dailyReportSiesa/DailyReportSiesa.vue")
  },
  data: () => ({
    file: [],
    message_of_modal: "",
    processing: false
  }),
  /*data() {
    return {
      id: null,
      loadFile: false,
      File: [],
      msgModal: '',
      // Autocomplete novedades
      timestamp: this.$moment().format("LL"),
      validated:false,

      // Mensajes alert
      msgAlertColaborador : '',

      // Modal
      modal_title: '¡Tu reporte se ha realizado exitosamente!',
      modal_msg: 'No olvides que tu reporte de novedad depende de la confirmación de tu jefé de Zona',
      modal_class: 'icon icon-success text-success',

      // response guardado
      response: [],
      checkedNovedad: false,
      descripcion: '',
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
     
    };
  },*/
  computed: {
    /*...mapState("modCore", ["user", "userData"]),

    ...mapState("modTipFileUpload", 
      [
        "errorMsj",
        "loading", 
        "loadingFile",
      ]
    ),
    */
    ...mapGetters("modSiesaTips", [
      "getErrors"
    ]),
    modal_name() {
      return "modal-tips-file-upload"
    }
  },
  methods: {
    ...mapActions("modSiesaTips", [
      "uploadFile"
    ]),
    /* ...mapActions("modTipFileUpload", [
      "actSaveFileSiesa", "actSetMsg"
    ]), */

    /* resetFile(){
      this.file = [];
      let msg = "";
      this.actSetMsg(msg);
    } */
    reset_file() {
      this.file = []
    },
    dragFile(e) {
      this.file = e.target.files
      this.submitForm()
    },
    async submitForm() {
      const self = this
      const form = new FormData()
      form.append('file', self.file[0])
      self.processing = true
      await this.uploadFile(form)
      self.processing = false


      /*var formData = new FormData();
      formData.append("file", this.File[0]);
      
      console.log('debuug', formData);
      this.actSaveFileSiesa(formData).then((response) =>{
        console.log('dev', formData, response);
        if(this.getErrorMsj != ''){
          this.msgModal = this.getErrorMsj;
          // Limpiar contenido.
          this.resetFile();            
          // Mostrar ventana modal con el error.
          this.$bvModal.show('modal-msg');
        }
        console.log('Respuesta',response, '::' + this.errorMsj, '::' + this.getErrorMsj);
      }).catch((response) => {
        console.log("respuesta error", response);
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message = "Error subiendo el archivo: "+response;
      });*/
    }

    /* showModal(msj,flag) {
        this.msjModal = msj;
        this.flagPath = flag;
        this.$refs['my-modal'].show()
      },

    hideModal() {
        this.$refs['my-modal'].hide()
        if(this.flagPath == 1){
          this.$router.push({ path: '/solicitudes' });
        }
     },

    hideModalAvailability(){
      this.$router.push({ path: '/solicitudes' });
    },
    hideModalSociety(){
       this.society = [];
       this.$refs['my-modal-society'].hide();
     }*/
  },

}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');

.page-tipsfileUpload {


  .highlight-success {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 4px;
    gap: 8px;

    width: 444px;
    height: 36px;

    /* highlight/success ok/background */

    background: #F6FFED;
    /* highlight/success ok/medium */

    border: 1px solid #0C9E42;
    border-radius: 4px;
  }

  .title-3 {
    font-size: 24px;
    font-weight: bold;
    color: #1C3A4E;
  }

  .cont-request-text {
    .cont-title {
      color: #1c3a4e;

      .title-1 {
        font-size: 40px;
        font-weight: bold;
      }

      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }

    .form-request {
      .button1 {
        font-family: "Open Sans";
        background: #E9ECEE;
        color: #1C3A4E;
        font-weight: bold;
        height: 32px;
        font-size: 14px;
        text-align: left !important;
        padding-left: 5%;
        padding-right: 5%;
        outline: none;
        border: none;

        &:hover {
          background: darken(#cddce6, 5);
          border: none;
        }
      }

      .button2 {
        background: #8d9092;
        color: #ffffff;
        border-color: #8d9092;
        font-family: "Poppins";
        border-radius: 100px;
        height: 42px;
        width: 220px;
        font-size: 14px;
        text-align: center !important;
        padding-left: 2%;
        padding-right: 2%;

        &:hover {
          background: darken(#7a7c7e, 5);
        }

        .button3 {
          border-radius: 50px;
          font-family: "Open Sans";
          color: #1c3a4e;
          font-size: 20px;
          border: 0 none;
          outline: none;
          text-decoration: none;
          border: 2px solid #1c3a4e;
        }
      }
    }
  }

  .p1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
  }

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #979494;
    text-align: center !important;
  }

  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #999797;
  }

  .center {
    display: flex;
    align-items: center;
  }

  .button4 {
    background: #99A6AF;
    color: #ffffff;
    border-radius: 8px;
    height: 20px;
    font-size: 8px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;

    &:hover {
      background: darken(#99A6AF, 5);
    }
  }

  .collapsed>.when-opened,
  :not(.collapsed)>.when-closed {
    display: none;
  }

  .centerImg2 {
    vertical-align: middle;
    position: relative;
    bottom: 2px;
    padding-right: 2%;
  }

  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }

  .mycheck {
    width: 1.3em;
    height: 1.3em;

    border-radius: 30%;
    vertical-align: middle;
    border: 1px solid #ddd;
    //-webkit-appearance: none;
  }

  .mycheck:checked {
    background-color: #1C3A4E;
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked+.slider {
    background-color: #779B49;
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #779B49;
  }

  input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .style-filter .vs__search::placeholder,
  .style-filter .vs__dropdown-toggle,
  .style-filter .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
    font-size: 11px;
    line-height: 12px;
  }

  .style-filter .vs__clear,
  .style-filter .vs__open-indicator {
    fill: #394066;
  }

  /* Center the loader */
  #loader {
    position: relative;
    z-index: 1072;
    left: 50%;
    top: 50%;
    z-index: 1;

    margin: -75px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  .content-loader {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1071;
    background-color: #fff;
    opacity: 0.9;
  }


  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0
    }

    to {
      bottom: 0px;
      opacity: 1
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0
    }

    to {
      bottom: 0;
      opacity: 1
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }

  .card-header {
    background-color: none !important;
  }

  .chips {
    /* Auto Layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    width: 61px;
    left: calc(50% - 61px/2 - 127.5px);
    top: 0%;
    bottom: 0%;
    /* Alert / Error Bg */
    background: #FEEFEF;
    border-radius: 4px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .iconClose {
    /* Alert/Error */
    color: #DA1414;
  }

  .iconPendiente {
    /* Alert/Error */
    color: #E06100;
  }

  .iconProceso {
    /* Alert/Error */
    color: #2E5AAC;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  .textClose {
    position: static;
    height: 16px;
    left: 22px;
    right: 4px;
    top: calc(50% - 16px/2);
    /* Placeholder */
    font-family: Open Sans;
    font-style: italic;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    /* Alert/Error */
    color: #DA1414;
  }



  .card-header-left {
    /* Neutral / Gray blue light */
    background: #F5F5F5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;
  }

  .card-header-text {
    /* Header Tablas */
    font-family: Open Sans;
    font-style: normal;

    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #0C9E42;
  }

  /*
  .card-personalizada{
    flex-direction: column;
    background: #FFFFFF;
  

    border: 1px solid #DDDDDD;
    box-sizing: border-box;
   
    box-shadow: 0px 6px 24px rgb(110 116 134 / 12%);
    border-radius: 8px;

  }*/
  .card-left {
    /* Auto Layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 0px 16px;
    /* Neutral / White */
    background: #FFFFFF;
    /* Neutral / Gray 3 */
    border: 1px solid #DDDDDD;
    box-sizing: border-box;
    /* up extra */
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
  }

  .card-text-name {
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 1 */
    color: #454545;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 0px 4px;

    /* Elipsis nombre */
    width: 120px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .ancho-completo {
    width: 100%
  }

  .card-text-name-bodega {
    /* Body Tablas - Párrafo mediano */
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 1 */
    color: #454545;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 0px 4px;

    /* Elipsis nombre */
    width: 50%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }

  .text-proceso {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #1C3A4E;
  }

  .text-pendiente {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #1C3A4E;
  }

  .chips-bodega-pendiente {
    /* Auto Layout */
    text-align: right;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    left: calc(50% - 61px/2 - 127.5px);
    top: 0%;
    bottom: 0%;
    width: 100px;
    /* Alert / Error Bg */
    background: #FFF4EC;
    border-radius: 20px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .chips-bodega-proceso {
    /* Auto Layout */
    text-align: right;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    left: calc(50% - 61px/2 - 127.5px);
    top: 0%;
    bottom: 0%;
    width: 100px;
    /* Alert / Error Bg */
    background: #EEF2FA;
    border-radius: 20px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .card-body {
    padding-top: 10px;
    padding-left: 0px;
    padding-bottom: 10px;
  }

  .card-text-cargo {
    /* Body Tablas - Párrafo mediano */

    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: right;

    /* Neutral / Gray 1 */

    color: #454545;


    /* Inside Auto Layout */

    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 0px 4px;

    // Elipsis cargo
    width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }



  .card-left-titulo {
    /* Header Tablas */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    /* Primary / 1 */
    color: #1C3A4E;
  }

  table {
    //border-collapse: collapse;
    border-radius: 8px !important;
  }

  thead>tr {
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    /* Alert / Info Bg */
    background: #EEF2FA;
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin: 0px 0px;

    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* Neutral / Black */
    color: #000000;
  }

  tbody>tr {
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* Neutral / Gray 1 */
    color: #454545;
  }

  table>input {
    border: 1px solid #AAAAAA;
    box-sizing: border-box;
    border-radius: 2px;
    background: #269887;
  }

  .selection-table {
    /* Neutral / Gray blue light */
    background: #F5F5F5;
    border-radius: 8px;
  }

  .custom-control-input:checked~.custom-control-label::before {
    color: #fff;
    border-color: #269887;
    background-color: #269887;
  }

  .checkbox-blue:checked~.checkbox-blue::before {
    color: #fff;
    border-color: #269887;
    background-color: #269887;
  }

  /*.btn{
    background: #269887;
    border: transparent;
  }

  .btn:hover{
    background: #1C6776;
    border: transparent;
  }*/

  .text-novedad-info {
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */
    display: flex;
    align-items: center;
    text-align: center;
    /* Primary / 3 */
    color: #269887;
  }

  // Tabla de reemplazos, rotativos, editar puntaje
  .tabs-novedades {
    .col-auto {
      background-color: transparent;
    }

    ul {
      background-color: transparent;
    }

    .nav-item {
      background-color: transparent;
      border-bottom: 1px solid #E9ECEE;
      width: 180px;

      a {
        color: black;
      }
    }

    .nav-pills {
      margin-left: 0px;
      padding-left: 0px;
      margin-top: 10px;
    }

    .nav-link {
      height: 80px;
      margin-left: 0px;
      padding-left: 0px;
      background-color: transparent;
      /* Botón */
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height */
      letter-spacing: 0.02em;
    }

    .nav-pills .nav-link.active,
    .nav-pills .show>.nav-link {
      color: black;
      background-color: white;
      /* Neutral / Black */
      color: #000000;
    }

    .page-tipsfileUpload .tabs .nav-link {
      /* Botón */
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height */
      letter-spacing: 0.02em;
      /* Neutral / Black */
      color: #000000;
      background-color: white;
    }

    .tab-title-content {
      height: 60px;
      padding-left: 5px;
      //border-left: 4px solid transparent;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    .nav-link.active>.tab-title-content {
      border-left: 4px solid #269887;
    }

    .tab-title-muted-ul {
      margin: 0px;
      padding: 0px;
    }

    .tab-title-muted {
      /* Body Semibold */
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      /* Primary / 3 */
      color: #269887;
    }

    .tab-title-r {
      color: #269887;
      //margin-top: 15px;
      vertical-align: middle;
    }

    .tab-title-r-10 {
      color: #269887;
      margin-top: 3px;

    }

    .card-header-novedad {
      /* Header Tablas */
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      /* identical to box height */
      color: #2f3d46;
      background: #F5F5F5;
    }

    .text-novedad-descripcion {
      /* Header Tablas */
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      /* Neutral / Gray 1 */
      color: #454545;
    }

    .text-novedad-buscar {
      /* Body Tablas - Párrafo mediano */
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      /* identical to box height */
      display: flex;
      align-items: center;
      justify-content: center;
      /* Neutral / Gray 1 */
      color: #454545;
    }
  }

  .text-buscar {
    background: #FFFFFF;
    /* Neutral / Gray 3 */
    border: 1px solid #DDDDDD;
    box-sizing: border-box;
    border-radius: 8px;

    .input-group-prepend {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .icon-search1 {
      color: #DADADA;
    }

    .icon-search1::before {
      display: flex;
      align-items: center;
      justify-content: center;
      vertical-align: center;
    }

    input {
      height: 40px;
      border: 0px;
      margin-left: -10px;
    }

    ::placeholder {
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #AAAAAA;
    }
  }

  .label-textarea {
    margin-top: 0px;
  }

  .label-textarea label {
    width: 150px;
    position: relative;
    top: 20px;
    left: 30px;
    margin-top: 0px;
    border-radius: 1px;
    background: white;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 2 */
    color: #AAAAAA;
    text-align: left;
  }

  .textarea-novedad {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #454545;

    background: #FFFFFF;
    border: 1px solid #AAAAAA;
    box-sizing: border-box;
    border-radius: 8px;
    width: 98%;
    height: 92px;
    margin-top: 10px;
    padding-top: 10px;
    scroll-behavior: auto;

    ::placeholder {
      margin-top: 100px;
    }
  }

  .reloj-letras {
    position: absolute;
    top: 31%;
    left: 7%;

    /* Subtítulos */
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    /* Neutral / White */
    color: #FFFFFF;
  }

  .contenedor-quitar {
    width: 100%;
  }

  .ver-historial {
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    /* Primary / 3 */
    color: #269887;
  }

  .btn-descartar {
    /* Primary / 3 */
    background: white;
    border-radius: 100px;
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #DA1414;
  }

  .btn-descartar:hover {
    /* Primary / 3 */
    background: white;
    border-radius: 100px;
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #DA1414;
  }

  .alert-custom-danger {
    /* Alert / Warning Bg */
    background: #FFF4EC;
    border-radius: 8px;
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* Neutral / Black */
    color: #000000;
    border: 0px;
  }

  .card-panel {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px;

  }

  .alert-panel {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px;

    position: static;

    /* Alert / Warning Bg */

    background: #FFF4EC;
    border-radius: 8px;

    /* Inside Auto Layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 0px 0px;
  }

  .text-alert-danger {
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;

    /* Neutral / Black */
    color: #000000;
  }

  .alert-cargado {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 4px;

    position: static;
    height: 30px;
    width: 100px;
    /* Alert / Succes bg */
    background: #EDF9F0;
    border-radius: 20px;
  }

  .alert-atraso {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 4px;

    position: static;
    height: 30px;
    width: 180px;
    /* Alert / Succes bg */
    background: #EDF9F0;
    border-radius: 20px;
  }

  .div-header {
    /* Auto Layout */

    display: flex;
    flex-direction: row;
    align-items: center;

    position: static;
    width: 100%;
    height: 36px;
    left: 12px;
    top: 12px;
    /* Neutral / Gray blue light */
    background: #F5F5F5;
    border-radius: 4px;
    /* Inside Auto Layout */
    margin: 0px 0px 15% 0px;
  }

  .div-content {
    padding-left: 15%;
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    color: #AAAAAA;
  }

  .cargando {
    border: 3px solid #f3f3f3;
    border-radius: 50%;
    border-top: 3px solid #3498db;
    width: 25px;
    height: 25px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  .drag-file {
    text-align: center;
    /* Auto layout */

    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    gap: 20px;

    width: 444px;
    height: 260px;

    /* content/00 */

    background: #FFFFFF;
    /* highlight/success ok/medium */

    border: 1px dashed #0C9E42;
    /* Bottom */

    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14);
    border-radius: 16px;
  }




}
</style>